import { Controller } from "@hotwired/stimulus"
import { notifySlackOAuthParent } from "../lib/slack_oauth_transport"

export default class extends Controller {
  static values = {
    channel: { type: String, default: "slack_oauth" }
  }

  connect() {
    const payload = this.readPayload()
    if (!payload) return

    notifySlackOAuthParent(payload, { channelName: this.channelValue })
    this.requestClose()
  }

  readPayload() {
    const el = document.getElementById("slack-oauth-callback-payload")
    if (!el?.textContent) return null
    try {
      return JSON.parse(el.textContent)
    } catch {
      return null
    }
  }

  requestClose() {
    window.close()
    setTimeout(() => window.close(), 300)
  }
}
